import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Box, Typography, CircularProgress, Grid, Button, Card, CardContent, Chip, IconButton, Dialog, DialogActions, DialogContent, DialogTitle, Alert, Drawer, List, ListItem, ListItemIcon, ListItemText, ListItemSecondaryAction, Divider, Avatar, TextField, FormControl, InputLabel, Select, MenuItem, Stack, FormHelperText, Badge, Switch, FormControlLabel, CardActions, Snackbar, Checkbox
} from "@mui/material";
import {
  ArrowBack, Edit, Delete, Visibility, CalendarToday, AttachMoney, Close, Image, InsertDriveFile, Download, CloudUpload, DeleteOutline, Person, Email, Phone, LocationOn, Payment, CheckCircle, Cancel, Pending, Notifications, Star, AccessTime, MonetizationOn, Group, TrendingUp, Schedule, PriorityHigh, LocalShipping, PaymentOutlined
} from "@mui/icons-material";
import { FaChevronLeft, FaChevronRight, FaSearchPlus, FaTimes } from 'react-icons/fa';
import { useSelector, useDispatch } from "react-redux";
import axiosInstance from "../../../utils/axios/axiosInstance";
import { toast } from "react-toastify";
import { userApiLoader } from "../../../action/loaderActions";
import { Link } from 'react-router-dom';

const NOTIFICATIONS_ENABLED = false;

const animationStyles = `<style>@keyframes pulse{0%{transform:scale(1);opacity:1}50%{transform:scale(1.05);opacity:0.8}100%{transform:scale(1);opacity:1}}@keyframes glow{0%{box-shadow:0 0 5px rgba(206,85,185,0.5)}50%{box-shadow:0 0 20px rgba(206,85,185,0.8)}100%{box-shadow:0 0 5px rgba(206,85,185,0.5)}}@keyframes bounce{0%,20%,53%,80%,100%{transform:translate3d(0,0,0)}40%,43%{transform:translate3d(0,-30px,0)}70%{transform:translate3d(0,-15px,0)}90%{transform:translate3d(0,-4px,0)}}.animate-pulse{animation:pulse 2s infinite}.animate-glow{animation:glow 2s infinite}.animate-bounce{animation:bounce 2s infinite}.payment-pending{border-left:4px solid #ce55b9!important;background:#ce55b9!important;opacity:0.1}.request-approved{border-left:4px solid #ce55b9!important;background:#ce55b9!important;opacity:0.1;box-shadow:0 4px 20px rgba(206,85,185,0.3)}.payment-completed{border-left:4px solid #ce55b9!important;background:#ce55b9!important;opacity:0.1;box-shadow:0 4px 20px rgba(206,85,185,0.3)}.pulse-border{animation:pulse 2s infinite;border-color:#ce55b9!important}.approved-celebration{background:#ce55b9;animation:glow 3s infinite}.payment-celebration{background:#ce55b9;animation:glow 3s infinite}.status-success{background:#ce55b9;color:white}.status-warning{background:#ce55b9;color:white}.status-paid{background:#ce55b9;color:white}</style>`;

const formatPrice = (price) => {
  const numPrice = parseFloat(price);
  return isNaN(numPrice) ? '0.00' : numPrice.toFixed(2);
};

const formatPriceNumber = (price) => {
  const numPrice = parseFloat(price);
  return isNaN(numPrice) ? 0 : numPrice;
};

const getConditionLabel = (val) => {
  switch (parseInt(val)) {
    case 1: return "New";
    case 2: return "Like New";
    case 3: return "Good";
    case 4: return "Fair";
    case 5: return "Poor";
    default: return "Not specified";
  }
};

const getShippingLabel = (val) => {
  switch (parseInt(val)) {
    case 1: return "Pickup Only";
    case 2: return "Delivery Only";
    default: return "Contact for details";
  }
};

const getPaymentLabel = (val) => {
  switch (parseInt(val)) {
    case 1: return "Cash";
    case 2: return "Card";
    case 3: return "Bank Transfer";
    case 4: return "Digital Wallet";
    case 5: return "Cryptocurrency";
    default: return "Contact for details";
  }
};

const getPaymentModeLabel = (paymentMode) => {
  if (typeof paymentMode === 'string') return paymentMode;
  switch (parseInt(paymentMode)) {
    case 1: return "Cash";
    case 2: return "Online";
    default: return "Contact for details";
  }
};

const getStatusInfo = (ad) => {
  if (ad.is_draft === 1 || ad.is_draft === true) {
    return { text: "Draft", color: "black", bgColor: "#df9929" };
  }
  if (ad.is_paid === 1 || ad.is_paid === true) {
    return { text: "Payment Completed", color: "info", bgColor: "#ce55b9" };
  }
  if (ad.is_sold === 1 || ad.is_sold === true || parseInt(ad.status) === 3) {
    return { text: "Sold", color: "info", bgColor: "#098c09" };
  }
  if (ad.buyer_requests && ad.buyer_requests.some(req => req.status === 'approved' || req.status === 'accepted' || req.status === 'confirmed')) {
    return { text: "Waiting for Payment", color: "warning", bgColor: "#ce55b9" };
  }
  switch (parseInt(ad.status)) {
    case 1: return { text: "Published", color: "#ffffff", bgColor: "#228ddc" };
    case 2: return { text: "Inactive", color: "#ffffff", bgColor: "#f01839" };
    default: return { text: "Published", color: "#ffffff", bgColor: "#228ddc" };
  }
};

const getBuyerRequestStatusInfo = (status, isPaidByBuyer = false) => {
  if (isPaidByBuyer) {
    return { text: "✅ PAYMENT COMPLETED", color: "info", icon: CheckCircle, bgColor: "#ce55b9", description: "Payment successfully completed by buyer" };
  }
  switch(status?.toLowerCase()) {
    case 'pending': return { text: "Pending Review", color: "warning", icon: Pending, bgColor: "#ce55b9", description: "Waiting for seller's decision" };
    case 'approved':
    case 'accepted':
    case 'confirmed': return { text: "✅ APPROVED - Payment Required", color: "success", icon: CheckCircle, bgColor: "#198754", description: "Request approved! Please proceed with payment" };
    case 'rejected':
    case 'declined': return { text: "Rejected", color: "error", icon: Cancel, bgColor: "#ce55b9", description: "Request was rejected by seller" };
    case 'paid':
    case 'completed':
    case 'fulfilled': return { text: "Payment Completed", color: "info", icon: CheckCircle, bgColor: "#ce55b9", description: "Payment successful - ready for pickup" };
    case 'cancelled': return { text: "Cancelled", color: "default", icon: Cancel, bgColor: "#f5f5f5", description: "Request was cancelled" };
    default: return { text: "Unknown Status", color: "default", icon: Pending, bgColor: "#f5f5f5", description: "Status unclear" };
  }
};

const processBuyerRequestsData = (rawRequests, isPaidByBuyer = false) => {
  if (!Array.isArray(rawRequests)) return [];
  return rawRequests.map(request => ({
    id: request.id,
    student_id: request.student_id,
    student_name: request.name || request.student_name || 'Unknown Student',
    email: request.email || 'Not provided',
    phone_number: request.phone_number || 'Not provided',
    profile_picture: request.profile_picture || null,
    amount: formatPriceNumber(request.amount),
    payment_mode: request.payment_mode,
    payment_mode_label: getPaymentModeLabel(request.payment_mode),
    pickup_location: request.pickup_location,
    pickup_date: request.pickup_date,
    pickup_time: request.pickup_time,
    status: isPaidByBuyer ? 'paid' : request.status,
    message: request.message || 'No message provided',
    requested_at: request.requested_at || formatDate(request.created_at),
    updated_at: request.updated_at,
    seller_response: request.seller_response || null,
    auto_rejected: request.auto_rejected || false,
    approved_at: request.approved_at || null,
    rejected_at: request.rejected_at || null,
    is_paid_by_buyer: isPaidByBuyer
  }));
};

const processAdData = (rawData) => {
  if (!rawData || typeof rawData !== 'object') {
    throw new Error('Invalid ad data received from API');
  }
  let adData = null;
  if (rawData.status === 200 && rawData.data) {
    adData = rawData.data;
  } else if (rawData.success && rawData.data) {
    adData = rawData.data;
  } else {
    adData = rawData;
  }
  if (!adData || !adData.id) {
    throw new Error('Ad data is missing required ID field');
  }

  const extractCondition = (data) => {
    const conditionValue = data.condition || data.ad_condition || data.item_condition || null;
    if (conditionValue === null || conditionValue === undefined) return null;
    if (typeof conditionValue === 'string') {
      const conditionMap = { 'new': 1, 'like new': 2, 'like_new': 2, 'good': 3, 'fair': 4, 'poor': 5 };
      const normalizedCondition = conditionValue.toLowerCase().trim();
      return conditionMap[normalizedCondition] || parseInt(conditionValue) || null;
    }
    return parseInt(conditionValue) || null;
  };

  const processThumbnail = (thumbnailData) => {
    if (Array.isArray(thumbnailData) && thumbnailData.length > 0) {
      return thumbnailData[0];
    }
    return thumbnailData || null;
  };

  const isPaidByBuyer = adData.is_paid === 1 || adData.is_paid === true;

  const processedAd = {
    ...adData,
    id: adData.id,
    title: adData.title || 'Untitled Ad',
    name: adData.title || 'Untitled Ad',
    description: adData.description || 'No description available',
    price: formatPriceNumber(adData.price || 0),
    images: processImages(adData),
    category_name: adData.category_name || 'Uncategorized',
    sub_category_name: adData.sub_category_name || null,
    condition_name: adData.condition_name || null,
    category_id: adData.category_id || null,
    sub_category_id: adData.sub_category_id || null,
    condition: extractCondition(adData),
    shipping_method: adData.shipping_option || adData.shipping_method || null,
    payment_method: adData.payment_methods || adData.payment_method || null,
    pickup_location: adData.location || adData.pickup_location || null,
    views: parseInt(adData.views || 0),
    is_sold: adData.is_sold === 1 || adData.is_sold === true,
    is_wishlisted: adData.is_wishlisted || false,
    status: adData.status || 1,
    is_draft: adData.is_draft || 0,
    is_paid: isPaidByBuyer,
    posted_on: adData.posted_on || formatDate(adData.created_at),
    updated_at: adData.updated_at || null,
    seller: adData.seller || null,
    buyer_requests: processBuyerRequestsData(adData.buyer_requests || [], isPaidByBuyer),
    thumbnail: processThumbnail(adData.thumbnail)
  };
  return processedAd;
};

const processImages = (adData) => {
  const images = [];
  if (adData.thumbnail && Array.isArray(adData.thumbnail)) {
    adData.thumbnail.forEach((thumbUrl, index) => {
      images.push({ image_url: thumbUrl, alt: `Thumbnail ${index + 1}` });
    });
  } else if (adData.thumbnail) {
    images.push({ image_url: adData.thumbnail, alt: 'Thumbnail' });
  }
  if (adData.images && Array.isArray(adData.images)) {
    adData.images.forEach((img, index) => {
      if (typeof img === 'string') {
        images.push({ image_url: img, alt: `Image ${index + 1}` });
      } else if (img?.image_url) {
        images.push({ image_url: img.image_url, alt: img.alt || `Image ${index + 1}`, id: img.id, created_at: img.created_at, updated_at: img.updated_at });
      }
    });
  }
  const uniqueImages = images.filter((img, index, self) => index === self.findIndex(i => i.image_url === img.image_url));
  return uniqueImages;
};

const formatDate = (dateString) => {
  if (!dateString) return 'Recently';
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return 'Recently';
    const now = new Date();
    const diffTime = Math.abs(now - date);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    if (diffDays === 1) return 'Yesterday';
    if (diffDays < 7) return `${diffDays} days ago`;
    if (diffDays < 30) return `${Math.ceil(diffDays / 7)} weeks ago`;
    return date.toLocaleDateString();
  } catch {
    return 'Recently';
  }
};

const validateApiResponse = (response) => {
  if (typeof response.data === 'string') {
    if (response.data.includes('import') || response.data.includes('function') || response.data.includes('const')) {
      throw new Error('API returned file content instead of ad data. Please check the API endpoint.');
    }
    try {
      return JSON.parse(response.data);
    } catch {
      throw new Error('Invalid API response format');
    }
  }
  return response.data;
};

const sendNotificationToUser = async (userId, message, type, accessToken, additionalData = {}) => {
  if (!NOTIFICATIONS_ENABLED) {
  //  toast.info(`📧 Notification preview: ${message.substring(0, 80)}...`, { position: "top-right", autoClose: 4000 });
    return true;
  }
  try {
    const response = await axiosInstance.post(`${process.env.REACT_APP_USER_MANAGEMENT_API_BASE_URL}/v1/notification/send`, {
      user_id: userId, message: message, type: type, title: 'Buyer Request Update', ...additionalData
    }, {
      headers: { Authorization: `Bearer ${accessToken}`, 'Content-Type': 'application/json' }
    });
    return true;
  } catch (error) {
    toast.error("Failed to send notification", { autoClose: 3000 });
    return false;
  }
};

const NotificationBadge = ({ buyerRequests, onRequestsClick, isPaid }) => {
  const pendingCount = buyerRequests.filter(req => req.status === 'pending').length;
  const approvedCount = buyerRequests.filter(req => req.status === 'approved' || req.status === 'accepted').length;
  const paidCount = buyerRequests.filter(req => req.status === 'paid' || req.is_paid_by_buyer).length;
  if (buyerRequests.length === 0) return null;
  let buttonText = 'Buyer Requests';
  let buttonColor = '#ce55b9';
  let hoverColor = '#b84ba3';
  let shouldAnimate = false;
  if (isPaid || paidCount > 0) {
    buttonText = 'Payment Completed';
    shouldAnimate = true;
  } else if (approvedCount > 0) {
    buttonText = 'Payment Pending';
    shouldAnimate = true;
  }
  return (
    <Badge badgeContent={pendingCount} color="error" sx={{ '& .MuiBadge-badge': { animation: pendingCount > 0 ? 'pulse 2s infinite' : 'none' } }}>
      <Button variant="contained" startIcon={<Notifications />} onClick={onRequestsClick} className={shouldAnimate ? "animate-pulse" : ""} sx={{ bgcolor: buttonColor, '&:hover': { bgcolor: hoverColor }, fontWeight: 'bold' }}>
        {buttonText} ({buyerRequests.length})
      </Button>
    </Badge>
  );
};

const PaymentCompletedStatusCard = ({ request, ad }) => {
  return (
    <Card className="payment-celebration" sx={{ mb: 3, border: '3px solid #ce55b9', borderRadius: '16px', overflow: 'hidden' }}>
      <CardContent sx={{ p: 0 }}>
        <div style={{ background: '#ce55b9', color: 'white', padding: '16px' }}>
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="animate-bounce"><CheckCircle sx={{ fontSize: 40 }} /></div>
              <div>
                <Typography variant="h5" sx={{ fontWeight: 'bold' }}>💰 PAYMENT COMPLETED!</Typography>
                <Typography variant="body2" sx={{ opacity: 0.9 }}>{request.student_name} - Transaction Successful</Typography>
              </div>
            </div>
            <Chip label="PAID" sx={{ bgcolor: 'rgba(255,255,255,0.2)', color: 'white', fontWeight: 'bold' }} />
          </div>
        </div>
        <div style={{ padding: '16px', backgroundColor: '#f8f4f7' }}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <div className="text-center p-3 bg-white rounded-lg shadow-sm">
                <MonetizationOn sx={{ fontSize: 32, color: '#ce55b9', mb: 1 }} />
                <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#ce55b9' }}>${formatPrice(request.amount)}</Typography>
                <Typography variant="body2" color="text.secondary">Amount Paid</Typography>
                <Typography variant="caption" sx={{ color: '#4caf50', fontWeight: 'bold' }}>✅ Transaction Complete</Typography>
              </div>
            </Grid>
            <Grid item xs={12} md={4}>
              <div className="text-center p-3 bg-white rounded-lg shadow-sm">
                <PaymentOutlined sx={{ fontSize: 32, color: '#ce55b9', mb: 1 }} />
                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>{request.payment_mode_label}</Typography>
                <Typography variant="body2" color="text.secondary">Payment Method</Typography>
              </div>
            </Grid>
            <Grid item xs={12} md={4}>
              <div className="text-center p-3 bg-white rounded-lg shadow-sm">
                <Schedule sx={{ fontSize: 32, color: '#ff9800', mb: 1 }} />
                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>{request.pickup_date}</Typography>
                <Typography variant="body1" sx={{ fontWeight: 'medium' }}>{request.pickup_time}</Typography>
                <Typography variant="body2" color="text.secondary">Pickup Schedule</Typography>
              </div>
            </Grid>
          </Grid>
        </div>
        <div style={{ padding: '16px', backgroundColor: '#f0fdf4' }}>
          <Alert severity="success" sx={{ mb: 2 }}>
            <Typography variant="body1" sx={{ fontWeight: 'bold' }}>🎉 Transaction Successfully Completed!</Typography>
          </Alert>
          <div className="space-y-2">
            <Typography variant="body2" sx={{ fontWeight: 'medium' }}>📍 <strong>Pickup Location:</strong> {request.pickup_location}</Typography>
            {request.message && request.message !== 'No message provided' && (
              <Typography variant="body2">💬 <strong>Buyer's Note:</strong> "{request.message}"</Typography>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

const ApprovedStatusCard = ({ request, ad }) => {
  const [timeRemaining, setTimeRemaining] = useState('');
  useEffect(() => {
    if (request.approved_at) {
      const interval = setInterval(() => {
        const now = new Date();
        const approvedTime = new Date(request.approved_at);
        const diffHours = Math.floor((now - approvedTime) / (1000 * 60 * 60));
        const diffMinutes = Math.floor((now - approvedTime) / (1000 * 60)) % 60;
        if (diffHours > 0) {
          setTimeRemaining(`${diffHours}h ${diffMinutes}m ago`);
        } else {
          setTimeRemaining(`${diffMinutes}m ago`);
        }
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [request.approved_at]);

  return (
    <Card className="approved-celebration" sx={{ mb: 3, border: '3px solid #4caf50', borderRadius: '16px', overflow: 'hidden' }}>
      <CardContent sx={{ p: 0 }}>
        <div style={{ background: '#4caf50', color: 'white', padding: '16px' }}>
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="animate-bounce"><CheckCircle sx={{ fontSize: 40 }} /></div>
              <div>
                <Typography variant="h5" sx={{ fontWeight: 'bold' }}>🎉 REQUEST APPROVED!</Typography>
                <Typography variant="body2" sx={{ opacity: 0.9 }}>{request.student_name} - Approved {timeRemaining}</Typography>
              </div>
            </div>
            <Chip label="SUCCESS" sx={{ bgcolor: 'rgba(255,255,255,0.2)', color: 'white', fontWeight: 'bold' }} />
          </div>
        </div>
        <div style={{ padding: '16px', backgroundColor: '#fff' }}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <div className="text-center p-3 bg-white rounded-lg shadow-sm">
                <MonetizationOn sx={{ fontSize: 32, color: '#ce55b9', mb: 1 }} />
                <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#ce55b9' }}>${formatPrice(request.amount)}</Typography>
                <Typography variant="body2" color="text.secondary">Payment Amount</Typography>
                {parseFloat(request.amount) !== ad.price && (
                  <Typography variant="caption" sx={{ color: parseFloat(request.amount) > ad.price ? 'green' : 'orange', fontWeight: 'bold' }}>
                    {parseFloat(request.amount) > ad.price ? '↗️' : '↘️'} ${formatPrice(Math.abs(parseFloat(request.amount) - ad.price))} vs listed
                  </Typography>
                )}
              </div>
            </Grid>
            <Grid item xs={12} md={4}>
              <div className="text-center p-3 bg-white rounded-lg shadow-sm">
                <PaymentOutlined sx={{ fontSize: 32, color: '#ce55b9', mb: 1 }} />
                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>{request.payment_mode_label}</Typography>
                <Typography variant="body2" color="text.secondary">Payment Method</Typography>
              </div>
            </Grid>
            <Grid item xs={12} md={4}>
              <div className="text-center p-3 bg-white rounded-lg shadow-sm">
                <Schedule sx={{ fontSize: 32, color: '#ff9800', mb: 1 }} />
                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>{request.pickup_date}</Typography>
                <Typography variant="body1" sx={{ fontWeight: 'medium' }}>{request.pickup_time}</Typography>
                <Typography variant="body2" color="text.secondary">Pickup Schedule</Typography>
              </div>
            </Grid>
          </Grid>
        </div>
        <div style={{ padding: '16px', backgroundColor: '#fff' }}>
          <Alert severity="warning" sx={{ mb: 2 }}>
            <Typography variant="body1" sx={{ fontWeight: 'bold' }}>⏰ Waiting for Payment Completion</Typography>
          </Alert>
          <div className="space-y-2">
            <Typography variant="body2" sx={{ fontWeight: 'medium' }}>📍 <strong>Pickup Location:</strong> {request.pickup_location}</Typography>
            {request.message && request.message !== 'No message provided' && (
              <Typography variant="body2">💬 <strong>Buyer's Note:</strong> "{request.message}"</Typography>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

const AdsDetailsPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [ad, setAd] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [isZoomOpen, setIsZoomOpen] = useState(false);
  const [processedRequests, setProcessedRequests] = useState(new Set());
  const [showApprovalCelebration, setShowApprovalCelebration] = useState(false);
  const [showPaymentCelebration, setShowPaymentCelebration] = useState(false);
  const [soldLoading, setSoldLoading] = useState(false);
  const [soldConfirmOpen, setSoldConfirmOpen] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [paymentConfirmed, setPaymentConfirmed] = useState(false);

  const { accessToken } = useSelector((state) => state.user);
  const buyerRequests = ad?.buyer_requests || [];

  const isAdSold = () => {
    return ad?.is_sold === 1 || ad?.is_sold === true;
  };

  const handleMarkAsSold = async () => {
    if (isAdSold() || soldLoading) return;
    try {
      setSoldLoading(true);
      dispatch(userApiLoader({ isApiLoader: true }));
      const response = await axiosInstance.post(`${process.env.REACT_APP_MARKET_PLACE_API_BASE_URL}v1/ads/sold_status`, 
        { id: parseInt(ad.id), is_sold: 1 },
        { headers: { Authorization: `Bearer ${accessToken}`, 'Content-Type': 'application/json' } }
      );
      if (response.data.status === 200) {
        const successMessage = response.data.message || "Ad marked as sold successfully!";
        if (response.data.data) {
          setAd(prevAd => ({ ...prevAd, ...response.data.data, is_sold: response.data.data.is_sold || 1 }));
        }
        toast.success(successMessage, { position: "top-center", autoClose: 3000 });
        setTimeout(async () => { await refetchAdDetails(); }, 1000);
      } else {
        throw new Error(response.data.message || "Failed to mark ad as sold");
      }
    } catch (error) {
      let errorMessage = "Failed to mark ad as sold";
      if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        errorMessage = error.message;
      }
      toast.error(errorMessage, { position: "top-center", autoClose: 5000 });
    } finally {
      setSoldLoading(false);
      setSoldConfirmOpen(false);
      dispatch(userApiLoader({ isApiLoader: false }));
    }
  };

  const handleDelete = async () => {
    try {
      setDeleteLoading(true);
      dispatch(userApiLoader({ isApiLoader: true }));
      toast.info("Deleting ad...", { position: "top-center", autoClose: 2000 });
      const response = await axiosInstance.delete(`${process.env.REACT_APP_MARKET_PLACE_API_BASE_URL}v1/ads`, {
        headers: { Authorization: `Bearer ${accessToken}`, 'Accept': 'application/json', 'Content-Type': 'application/json' },
        data: { id: parseInt(id) },
        timeout: 10000
      });
      if (response.data.status === 200 || response.status === 200) {
        const successMessage = response.data.message || "Ad deleted successfully";
        toast.success(`✅ ${successMessage}`, { position: "top-center", autoClose: 3000 });
        setDeleteDialogOpen(false);
        setTimeout(() => { navigate("/myaccount/mylisting"); }, 1500);
      } else {
        const errorMessage = response.data.message || "Error while deleting ad";
        throw new Error(errorMessage);
      }
    } catch (error) {
      let errorMessage = "Failed to delete ad";
      let isConstraintError = false;
      if (error.code === 'ECONNABORTED') {
        errorMessage = "Request timeout - please try again";
      } else if (error.response?.status === 404) {
        errorMessage = "Ad not found or already deleted";
      } else if (error.response?.status === 403) {
        errorMessage = "You don't have permission to delete this ad";
      } else if (error.response?.status === 401) {
        errorMessage = "Authentication failed - please login again";
      } else if (error.response?.status === 500) {
        const errorText = error.response?.data?.error || error.response?.data?.message || "";
        if (errorText.includes("foreign key constraint") || errorText.includes("Integrity constraint violation") || errorText.includes("Cannot delete or update a parent row")) {
          isConstraintError = true;
          errorMessage = "Cannot delete this ad because it has buyer requests or orders. Please mark it as sold instead.";
        } else {
          errorMessage = error.response?.data?.message || "Server error occurred while deleting the ad";
        }
      } else if (error.response?.data?.status === 400) {
        errorMessage = error.response.data.message || "Bad request - invalid ad ID";
      } else if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        errorMessage = error.message;
      }
      if (isConstraintError) {
        toast.error(`🚫 ${errorMessage}`, { position: "top-center", autoClose: 8000 });
        setTimeout(() => {
          toast.info("💡 Tip: Use 'Mark as Sold' instead to indicate the item is no longer available", { position: "top-center", autoClose: 6000 });
        }, 2000);
      } else {
        toast.error(`❌ ${errorMessage}`, { position: "top-center", autoClose: 5000 });
      }
    } finally {
      setDeleteLoading(false);
      dispatch(userApiLoader({ isApiLoader: false }));
      setTimeout(() => { setDeleteDialogOpen(false); }, 1000);
    }
  };

  const handleBuyerRequestAction = async (requestId, action) => {
    try {
      dispatch(userApiLoader({ isApiLoader: true }));
      const currentRequest = buyerRequests.find(req => req.id === requestId);
      if (!currentRequest) {
        toast.error("Request not found");
        return;
      }
      if (currentRequest.status !== 'pending') {
        toast.warning(`Request has already been ${currentRequest.status}`);
        return;
      }
      const apiEndpoint = `${process.env.REACT_APP_MARKET_PLACE_API_BASE_URL}v1/orders/buy_request/${requestId}/status`;
      const payload = { status: action === 'accept' ? 'approved' : 'rejected' };
      const response = await axiosInstance.post(apiEndpoint, payload, {
        headers: { Authorization: `Bearer ${accessToken}`, 'Content-Type': 'application/json' }
      });
      if (response.data.status === 200 || response.data.success) {
        const successMessage = response.data.message || `Request ${action === 'accept' ? 'approved' : 'rejected'} successfully!`;
        setProcessedRequests(prev => new Set([...prev, requestId]));
        if (action === 'accept') {
          setShowApprovalCelebration(true);
          setTimeout(() => setShowApprovalCelebration(false), 5000);
          toast.success(`🎉 REQUEST APPROVED! ${currentRequest.student_name} will be notified.`, { position: "top-center", autoClose: 5000 });
          setTimeout(() => {
            toast.success(successMessage, { position: "top-center", autoClose: 4000 });
          }, 1000);
          setTimeout(() => {
            sendNotificationToUser(currentRequest.student_id, `🎉 Congratulations! Your request for "${ad.title}" has been APPROVED! Please proceed with payment of $${formatPrice(currentRequest.amount)} and prepare for pickup on ${currentRequest.pickup_date} at ${currentRequest.pickup_time}.`, 'approval', accessToken, {
              ad_id: ad.id, request_id: requestId, amount: currentRequest.amount, pickup_date: currentRequest.pickup_date, pickup_time: currentRequest.pickup_time, pickup_location: currentRequest.pickup_location
            });
          }, 1500);
        } else {
          toast.success(`✅ Request #${requestId} REJECTED!`, { position: "top-center", autoClose: 3000 });
          setTimeout(() => {
            toast.success(successMessage, { position: "top-center", autoClose: 4000 });
          }, 500);
          setTimeout(() => {
            sendNotificationToUser(currentRequest.student_id, `Your request for "${ad.title}" has been rejected by the seller. You can explore other similar items on CampusCrow.`, 'rejection', accessToken);
          }, 1000);
        }
        setTimeout(async () => { await refetchAdDetails(); }, 3000);
      } else {
        throw new Error(response.data.message || `Failed to ${action === 'accept' ? 'approve' : 'reject'} request`);
      }
    } catch (error) {
      let errorMessage = `Failed to ${action === 'accept' ? 'approve' : 'reject'} request`;
      if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error.response?.data?.error) {
        errorMessage = error.response.data.error;
      } else if (error.message) {
        errorMessage = error.message;
      }
      toast.error(errorMessage, { position: "top-center", autoClose: 5000 });
      setProcessedRequests(prev => {
        const newSet = new Set(prev);
        newSet.delete(requestId);
        return newSet;
      });
    } finally {
      dispatch(userApiLoader({ isApiLoader: false }));
    }
  };

  const renderBuyerRequestCard = (request, index) => {
    const statusInfo = getBuyerRequestStatusInfo(request.status, request.is_paid_by_buyer);
    const StatusIcon = statusInfo.icon;
    const isPending = request.status === 'pending';
    const isApproved = request.status === 'approved' || request.status === 'accepted' || request.status === 'confirmed';
    const isRejected = request.status === 'rejected' || request.status === 'declined';
    const isPaid = request.status === 'paid' || request.is_paid_by_buyer;
    const isHighOffer = parseFloat(request.amount) > ad.price;
    const isProcessing = processedRequests.has(request.id);
    
    if (isPaid) {
      return (
        <Grid item xs={12} key={request.id || index}>
          <PaymentCompletedStatusCard request={request} ad={ad} />
        </Grid>
      );
    }
    if (isApproved) {
      return (
        <Grid item xs={12} key={request.id || index}>
          <ApprovedStatusCard request={request} ad={ad} />
        </Grid>
      );
    }
    
    return (
      <Grid item xs={12} sm={6} lg={4} key={request.id || index}>
        <Card sx={{ height: '100%', position: 'relative', border: isPending ? '2px solid #ce55b9' : isRejected ? '2px solid #f44336' : '1px solid #e0e0e0', transition: 'all 0.3s ease', '&:hover': { boxShadow: 6, transform: 'translateY(-2px)' }, opacity: isProcessing ? 0.7 : 1 }} className={isPending ? 'pulse-border' : ''}>
          <div className="absolute top-3 right-3 z-10">
            <Chip icon={<StatusIcon fontSize="small" />} label={isProcessing ? 'Processing...' : statusInfo.text} size="small" sx={{ backgroundColor: isProcessing ? '#ff9800' : statusInfo.bgColor, fontWeight: 'bold', border: isPending ? '2px solid #ce55b9' : isRejected ? '2px solid #f44336' : 'none' }} />
          </div>
          {isHighOffer && (
            <div className="absolute top-3 left-3 z-10">
              <Chip icon={<TrendingUp fontSize="small" />} label="High Offer" size="small" sx={{ backgroundColor: '#ce55b9', color: 'white', fontWeight: 'bold' }} />
            </div>
          )}
          {request.auto_rejected && (
            <div className="absolute top-12 left-3 z-10">
              <Chip label="Auto-rejected" size="small" sx={{ backgroundColor: '#ff5722', color: 'white', fontWeight: 'bold' }} />
            </div>
          )}
          <CardContent sx={{ pb: 0 }}>
            <div className="flex items-center space-x-3 mb-4">
              <Avatar src={request.profile_picture} alt={request.student_name} sx={{ width: 50, height: 50 }}>
                {request.student_name?.charAt(0)?.toUpperCase()}
              </Avatar>
              <div className="flex-1">
                <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 0.5 }}>{request.student_name}</Typography>
                <Typography variant="body2" color="text.secondary">{request.email}</Typography>
                {request.phone_number && request.phone_number !== 'Not provided' && (
                  <Typography variant="body2" color="text.secondary">📞 {request.phone_number}</Typography>
                )}
              </div>
            </div>
            <div style={{ backgroundColor: '#f0fdf4', borderRadius: '8px', padding: '12px', marginBottom: '12px' }}>
              <div className="flex items-center justify-between">
                <Typography variant="body2" color="text.secondary">Offer Amount</Typography>
                <MonetizationOn color="success" fontSize="small" />
              </div>
              <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'green.600' }}>${formatPrice(request.amount)}</Typography>
              <Typography variant="caption" color="text.secondary">
                vs ${formatPrice(ad.price)} listed
                {parseFloat(request.amount) !== ad.price && (
                  <span className={`ml-1 ${parseFloat(request.amount) > ad.price ? 'text-green-600' : 'text-orange-600'}`}>
                    ({parseFloat(request.amount) > ad.price ? '+' : ''}${formatPrice(parseFloat(request.amount) - ad.price)})
                  </span>
                )}
              </Typography>
            </div>
            <div className="grid grid-cols-2 gap-3 mb-4">
              <div className="flex items-center space-x-2">
                <Payment fontSize="small" color="primary" />
                <div>
                  <Typography variant="caption" color="text.secondary">Payment</Typography>
                  <Typography variant="body2" sx={{ fontWeight: 'medium' }}>{request.payment_mode_label}</Typography>
                </div>
              </div>
              <div className="flex items-center space-x-2">
                <LocationOn fontSize="small" color="error" />
                <div>
                  <Typography variant="caption" color="text.secondary">Location</Typography>
                  <Typography variant="body2" sx={{ fontWeight: 'medium' }}>{request.pickup_location || 'TBD'}</Typography>
                </div>
              </div>
            </div>
            <div style={{ backgroundColor: '#f0f9ff', borderRadius: '8px', padding: '12px', marginBottom: '12px' }}>
              <div className="flex items-center space-x-2 mb-2">
                <CalendarToday fontSize="small" color="primary" />
                <Typography variant="body2" sx={{ fontWeight: 'medium' }}>Pickup Schedule</Typography>
              </div>
              <div className="grid grid-cols-2 gap-2">
                <div>
                  <Typography variant="caption" color="text.secondary">Date</Typography>
                  <Typography variant="body2">{request.pickup_date}</Typography>
                </div>
                <div>
                  <Typography variant="caption" color="text.secondary">Time</Typography>
                  <Typography variant="body2">{request.pickup_time}</Typography>
                </div>
              </div>
            </div>
            {request.message && request.message !== 'No message provided' && (
              <div className="bg-gray-50 rounded-lg p-3 mb-3">
                <Typography variant="caption" color="text.secondary">Buyer's Message:</Typography>
                <Typography variant="body2" sx={{ fontStyle: 'italic' }}>"{request.message}"</Typography>
              </div>
            )}
            {request.seller_response && (
              <div style={{ backgroundColor: '#faf5ff', borderRadius: '8px', padding: '12px', marginBottom: '12px' }}>
                <Typography variant="caption" color="text.secondary">Your Response:</Typography>
                <Typography variant="body2">{request.seller_response}</Typography>
              </div>
            )}
            <div className="text-xs text-gray-500 space-y-1">
              <div>Requested: {request.requested_at}</div>
              {request.approved_at && <div>Approved: {formatDate(request.approved_at)}</div>}
              {request.rejected_at && <div>Rejected: {formatDate(request.rejected_at)}</div>}
            </div>
          </CardContent>
          <CardActions sx={{ px: 2, pb: 2 }}>
            {isPending && !isProcessing ? (
              <div className="w-full space-y-2">
                <Button variant="contained" color="success" startIcon={<CheckCircle />} onClick={() => handleBuyerRequestAction(request.id, 'accept')} fullWidth sx={{ fontWeight: 'bold' }} disabled={isProcessing}>
                  Approve Request
                </Button>
                <Button variant="outlined" color="error" startIcon={<Cancel />} onClick={() => handleBuyerRequestAction(request.id, 'reject')} fullWidth size="small" disabled={isProcessing}>
                  Reject Request
                </Button>
              </div>
            ) : isProcessing ? (
              <div className="w-full text-center">
                <Alert severity="info" sx={{ mb: 1 }}><strong>Processing...</strong></Alert>
                <div className="flex items-center justify-center space-x-2">
                  <CircularProgress size={16} />
                  <Typography variant="body2" color="text.secondary">Processing request</Typography>
                </div>
              </div>
            ) : (
              <div className="w-full text-center">
                <Typography variant="body2" color="text.secondary">
                  {isRejected ? (request.auto_rejected ? '🤖 Auto-rejected' : '❌ Request Rejected') : 'Action Completed'}
                </Typography>
                {request.auto_rejected && (
                  <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
                    Another request was approved first
                  </Typography>
                )}
              </div>
            )}
          </CardActions>
        </Card>
      </Grid>
    );
  };

  useEffect(() => {
    const fetchAdDetails = async () => {
      if (!id) {
        setError("Invalid ad ID");
        setLoading(false);
        return;
      }
      try {
        setLoading(true);
        setError(null);
        dispatch(userApiLoader({ isApiLoader: true }));
        const headers = { 'Accept': 'application/json', 'Content-Type': 'application/json' };
        if (accessToken) {
          headers.Authorization = `Bearer ${accessToken}`;
        }
        const response = await axiosInstance.get(`${process.env.REACT_APP_MARKET_PLACE_API_BASE_URL}v1/ads/detail_seller/${id}`, {
          headers, timeout: 10000, responseType: 'json'
        });
        const validatedData = validateApiResponse(response);
        const isPaidByBuyer = validatedData.is_paid === 1 || validatedData.is_paid === true;
        const isSoldItem = validatedData.is_sold === 1 || validatedData.is_sold === true;
        if (isPaidByBuyer) {
          setShowPaymentCelebration(true);
          setTimeout(() => setShowPaymentCelebration(false), 5000);
          toast.success("💰 Payment completed by buyer!", { position: "top-center", autoClose: 4000 });
        }
        if (isSoldItem) {
          toast.info("📦 This item is marked as sold", { position: "top-center", autoClose: 3000 });
        }
        const processedAd = processAdData(validatedData);
        setAd(processedAd);
      } catch (err) {
        let errorMessage = "Failed to fetch ad details";
        if (err.response) {
          const status = err.response.status;
          const responseData = err.response.data;
          if (typeof responseData === 'string' && responseData.includes('import')) {
            errorMessage = "API configuration error: receiving file content instead of JSON response";
          } else if (status === 404) {
            errorMessage = "Ad not found or you don't have permission to view this ad";
          } else if (status === 401) {
            errorMessage = "Unauthorized access - please log in";
          } else if (status === 403) {
            errorMessage = "Access denied - you can only view your own ads";
          } else if (status >= 500) {
            errorMessage = "Server error - please try again later";
          } else {
            errorMessage = responseData?.message || responseData?.error || errorMessage;
          }
        } else if (err.message) {
          errorMessage = err.message;
        }
        setError(errorMessage);
        toast.error(errorMessage);
      } finally {
        setLoading(false);
        dispatch(userApiLoader({ isApiLoader: false }));
      }
    };
    fetchAdDetails();
  }, [id, accessToken, dispatch]);

  useEffect(() => {
    const approvedRequests = buyerRequests.filter(req => req.status === 'approved' || req.status === 'accepted');
    if (approvedRequests.length > 0 && !ad?.is_paid) {
      const interval = setInterval(async () => { await refetchAdDetails(); }, 30000);
      return () => { clearInterval(interval); };
    }
  }, [buyerRequests, id, ad?.is_paid]);

  const nextImage = () => {
    if (ad?.images?.length > 0) {
      setCurrentImageIndex(prevIndex => prevIndex === ad.images.length - 1 ? 0 : prevIndex + 1);
    }
  };

  const prevImage = () => {
    if (ad?.images?.length > 0) {
      setCurrentImageIndex(prevIndex => prevIndex === 0 ? ad.images.length - 1 : prevIndex - 1);
    }
  };

  const goToImage = (index) => {
    setCurrentImageIndex(index);
  };

  const refetchAdDetails = async () => {
    try {
      const headers = { 'Accept': 'application/json', 'Content-Type': 'application/json' };
      if (accessToken) {
        headers.Authorization = `Bearer ${accessToken}`;
      }
      const response = await axiosInstance.get(`${process.env.REACT_APP_MARKET_PLACE_API_BASE_URL}v1/ads/detail_seller/${id}`, {
        headers, timeout: 10000, responseType: 'json'
      });
      const validatedData = validateApiResponse(response);
      const newIsPaid = validatedData.is_paid === 1 || validatedData.is_paid === true;
      const oldIsPaid = ad?.is_paid;
      if (newIsPaid && !oldIsPaid) {
        setShowPaymentCelebration(true);
        setTimeout(() => setShowPaymentCelebration(false), 5000);
        toast.success("🎉 Payment has been completed by the buyer!", { position: "top-center", autoClose: 5000 });
      }
      const processedAd = processAdData(validatedData);
      setAd(processedAd);
      setProcessedRequests(new Set());
    } catch (err) {
      console.warn("Failed to refetch ad details after update:", err.message);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <CircularProgress size={60} />
        <Typography variant="body1" sx={{ ml: 2 }}>Loading seller ad details...</Typography>
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-4 max-w-4xl mx-auto">
        <Alert severity="error" className="mb-4"><strong>Error!</strong> {error}</Alert>
        <Link to="/myaccount/mylisting" className="inline-flex items-center text-blue-600 hover:text-blue-800">
          <FaChevronLeft className="mr-2" /> Back to My Listings
        </Link>
      </div>
    );
  }

  if (!ad) {
    return (
      <div className="p-4 max-w-4xl mx-auto">
        <Alert severity="warning" className="mb-4"><strong>Not Found</strong> Ad with ID {id} not found or you don't have permission to view it.</Alert>
        <Link to="/myaccount/mylisting" className="inline-flex items-center text-blue-600 hover:text-blue-800">
          <FaChevronLeft className="mr-2" /> Back to My Listings
        </Link>
      </div>
    );
  }

  const statusInfo = getStatusInfo(ad);
  const images = ad.images || [];
  const seller = ad.seller || {};
  const pendingRequests = buyerRequests.filter(req => req.status === 'pending');
  const approvedRequests = buyerRequests.filter(req => req.status === 'approved' || req.status === 'accepted');
  const paidRequests = buyerRequests.filter(req => req.status === 'paid' || req.is_paid_by_buyer);

  return (
    <div className="container mx-auto px-4 py-8">
      <div dangerouslySetInnerHTML={{ __html: animationStyles }} />
      <Snackbar open={showApprovalCelebration} autoHideDuration={5000} onClose={() => setShowApprovalCelebration(false)} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <Alert severity="success" sx={{ width: '100%', fontWeight: 'bold' }}>🎉 Buyer request approved successfully! They've been notified to proceed with payment.</Alert>
      </Snackbar>
      <Snackbar open={showPaymentCelebration} autoHideDuration={5000} onClose={() => setShowPaymentCelebration(false)} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <Alert severity="info" sx={{ width: '100%', fontWeight: 'bold', bgcolor: '#ce55b9', color: 'white' }}>💰 Payment completed! Transaction successful - ready for pickup.</Alert>
      </Snackbar>
      <div className="mb-6 flex items-center justify-between flex-wrap gap-4">
        <Link to="/myaccount/mylisting" className="inline-flex items-center mb-6 text-blue-600 hover:text-blue-800">
          <FaChevronLeft className="mr-2" /> Back to My Listings
        </Link>
        <NotificationBadge buyerRequests={buyerRequests} isPaid={ad.is_paid} onRequestsClick={() => {
          const element = document.getElementById('buyer-requests-section');
          element?.scrollIntoView({ behavior: 'smooth' });
        }} />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        <div className="lg:col-span-2">
          <div className="bg-white rounded-lg shadow-md overflow-hidden mb-6">
            <div className="p-6">
              <div className="flex justify-between items-start mb-4 ads-details-top">
                <div>
                  <span className="inline-block px-3 py-1 text-sm font-semibold text-gray-700 bg-gray-100 rounded-full mb-2">{ad.category_name}</span>
                  <h1 className="text-3xl font-bold text-gray-900">{ad.title}</h1>
                  {ad.is_wishlisted && (
                    <div className="flex items-center mt-2 text-red-500">
                      <Star fontSize="small" className="mr-1" />
                      <Typography variant="body2">Wishlisted by buyers</Typography>
                    </div>
                  )}
                </div>
                <Chip label={soldLoading ? 'Updating...' : statusInfo.text} sx={{ backgroundColor: soldLoading ? '#ff9800' : statusInfo.bgColor, color: statusInfo.text === "Draft" ? 'black !important' : statusInfo.color }} size="medium" className={soldLoading ? "animate-pulse" : statusInfo.text === "Waiting for Payment" ? "animate-pulse" : statusInfo.text === "Payment Completed" ? "status-paid" : ""} />
              </div>
              <div className="flex items-center text-sm text-gray-500 mb-6 flex-wrap gap-4">
                <span className="flex items-center"><Visibility fontSize="small" className="mr-1" />Views: {ad.views}</span>
                <span className="flex items-center"><CalendarToday fontSize="small" className="mr-1" />Posted: {ad.posted_on}</span>
                <span className="flex items-center">ID: #{ad.id}</span>
              </div>
              <div className="relative mb-6">
                {images.length > 0 ? (
                  <div className="space-y-4">
                    <div className="relative">
                      <img src={images[currentImageIndex].image_url} alt={images[currentImageIndex].alt || ad.title} className="w-full h-96 object-contain rounded-lg bg-gray-100" onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'flex'; }} />
                      <div className="w-full h-96 bg-gray-100 rounded-lg flex items-center justify-center text-gray-500" style={{ display: 'none' }}>No image available</div>
                      <button onClick={() => setIsZoomOpen(true)} className="absolute bottom-2 right-2 bg-black bg-opacity-50 text-white p-2 rounded-full hover:bg-opacity-70 transition"><FaSearchPlus /></button>
                      {images.length > 1 && (
                        <>
                          <button onClick={prevImage} className="absolute left-2 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-50 text-white p-2 rounded-full hover:bg-opacity-70 transition"><FaChevronLeft /></button>
                          <button onClick={nextImage} className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-50 text-white p-2 rounded-full hover:bg-opacity-70 transition"><FaChevronRight /></button>
                        </>
                      )}
                    </div>
                    {images.length > 1 && (
                      <div className="flex justify-center space-x-2">
                        {images.map((_, index) => (
                          <button key={index} onClick={() => goToImage(index)} className={`w-3 h-3 rounded-full ${currentImageIndex === index ? 'bg-blue-500' : 'bg-gray-300'}`} />
                        ))}
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="w-full h-96 bg-gray-100 rounded-lg flex items-center justify-center text-gray-500">No image available</div>
                )}
              </div>
              {isZoomOpen && images.length > 0 && (
                <div className="fixed inset-0 bg-black bg-opacity-80 flex justify-center items-center z-50">
                  <div className="relative max-w-4xl w-full p-4 flex justify-center items-center">
                    <button onClick={() => setIsZoomOpen(false)} className="absolute top-4 right-4 text-white text-2xl hover:text-gray-300"><FaTimes /></button>
                    {images.length > 1 && (<button onClick={prevImage} className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-50 text-white p-2 rounded-full hover:bg-opacity-70 transition"><FaChevronLeft /></button>)}
                    <img src={images[currentImageIndex].image_url} alt={images[currentImageIndex].alt || ad.title} className="w-full max-h-[80vh] object-contain mx-auto" />
                    {images.length > 1 && (<button onClick={nextImage} className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-50 text-white p-2 rounded-full hover:bg-opacity-70 transition"><FaChevronRight /></button>)}
                  </div>
                </div>
              )}
              <div className="mb-8">
                <h2 className="text-xl font-bold mb-4 text-gray-800">Description</h2>
                <p className="text-gray-700 whitespace-pre-line">{ad.description}</p>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-md overflow-hidden mb-6">
            <div className='p-6'>
              <h3 className="text-lg font-semibold mb-3 text-gray-800">Item Details</h3>
              <ul className="space-y-2">
                <li className="flex justify-between"><span className="text-gray-600">Condition</span><span className="font-medium">{getConditionLabel(ad.condition)}</span></li>
                <li className="flex justify-between"><span className="text-gray-600">Status</span><span className={`font-medium ${isAdSold() ? 'text-blue-500' : 'text-green-500'}`}>{isAdSold() ? 'Sold' : 'Available'}</span></li>
                {ad.pickup_location && (ad.shipping_method === 1 || ad.shipping_method === "1") && (
                  <li className="flex justify-between"><span className="text-gray-600">Pickup Location</span><span className="font-medium">{ad.pickup_location}</span></li>
                )}
              </ul>
            </div>
          </div>
          <div className='bg-white rounded-lg shadow-md overflow-hidden mb-6'>
            <div className='p-6'>
              <h3 className="text-lg font-semibold mb-3 text-gray-800">Transaction Details</h3>
              <ul className="space-y-2">
                <li className="flex justify-between"><span className="text-gray-600">Price</span><span className="font-medium">${formatPrice(ad.price)}</span></li>
                <li className="flex justify-between"><span className="text-gray-600">Shipping</span><span className="font-medium">{getShippingLabel(ad.shipping_method)}</span></li>
                <li className="flex justify-between"><span className="text-gray-600">Payment Methods</span><span className="font-medium">{getPaymentLabel(ad.payment_method)}</span></li>
                {ad.is_paid && (<li className="flex justify-between"><span className="text-gray-600">Payment Status</span><span className="font-medium text-blue-600">✅ Completed</span></li>)}
              </ul>
            </div>
          </div>
        </div>
        <div className="lg:col-span-1">
          <div className="relative rounded-2xl shadow-xl text-white sticky top-4 overflow-hidden p-6 space-y-4 mb-6" style={{ backgroundColor: '#ce55b9' }}>
            <div className="absolute top-2 right-2 bg-yellow-300 text-yellow-900 text-xs font-bold px-2 py-1 rounded-full shadow">My Listing</div>
            <div className="text-center">
              <h2 className="text-5xl font-extrabold flex items-center justify-center"><AttachMoney fontSize="large" />{formatPrice(ad.price)}</h2>
              <p className="text-sm mt-1 opacity-80">Current listing price</p>
             
            </div>
            <div className="space-y-3 pt-4">
              <Button variant="contained" fullWidth onClick={() => navigate(`/myaccount/mylisting/edit/${ad.id}`)} style={{ backgroundColor: ad.is_paid ? '#9e9e9e' : isAdSold() ? '#933983' : 'white', color: ad.is_paid ? 'white' : isAdSold() ? 'white' : '#ce55b9' }} disabled={ad.is_paid || isAdSold()}>
                {ad.is_paid ? 'Payment Completed' : isAdSold() ? 'Item Sold' : 'Edit Listing'}
              </Button>
              <Button startIcon={deleteLoading ? <CircularProgress size={16} color="inherit" /> : <Delete />} variant="outlined" fullWidth color="error" onClick={() => setDeleteDialogOpen(true)} style={{ borderColor: 'white', color: 'white' }} disabled={deleteLoading} className={deleteLoading ? "animate-pulse" : ""}>
                {deleteLoading ? 'Deleting...' : 'Delete Listing'}
              </Button>
            </div>
          </div>
          {!isAdSold() && (
            <div className="bg-white rounded-lg shadow-md overflow-hidden mb-6">
              <div className="p-6">
                <div className="text-center">
                  <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, color: '#ce55b9' }}>Item Management</Typography>
                  
                  {/* Payment Confirmation Checkbox */}
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={paymentConfirmed}
                        onChange={(e) => setPaymentConfirmed(e.target.checked)}
                        sx={{
                          color: '#ce55b9',
                          '&.Mui-checked': {
                            color: '#ce55b9',
                          },
                        }}
                      />
                    }
                    label={
                      <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
                        I confirm that payment has been received from the buyer
                      </Typography>
                    }
                    sx={{ mb: 2, alignItems: 'flex-start' }}
                  />
                  
                  <Button variant="contained" fullWidth startIcon={<CheckCircle />} onClick={() => setSoldConfirmOpen(true)} disabled={soldLoading || !paymentConfirmed} sx={{ bgcolor: paymentConfirmed ? '#4caf50' : '#bdbdbd', '&:hover': { bgcolor: paymentConfirmed ? '#45a049' : '#bdbdbd' }, fontWeight: 'bold', py: 1.5, mb: 2 }} className={soldLoading ? "animate-pulse" : ""}>
                    {soldLoading ? 'Marking as Sold...' : 'Mark as Sold'}
                  </Button>
                  <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2 }}>Mark this item as sold when transaction is complete</Typography>
                  {!paymentConfirmed && (
                    <Alert severity="info" sx={{ textAlign: 'left', mb: 2 }}>
                      <strong>Note:</strong> Please confirm payment receipt above to enable the "Mark as Sold" option.
                    </Alert>
                  )}
                  {buyerRequests.length > 0 && (<Alert severity="info" sx={{ textAlign: 'left' }}><strong>Note:</strong> This ad cannot be deleted because it has {buyerRequests.length} buyer request(s). Use "Mark as Sold" instead to indicate the item is no longer available.</Alert>)}
                  {buyerRequests.length === 0 && !ad.is_paid && (<Alert severity="success" sx={{ textAlign: 'left' }}><strong>✅ Deletion Available:</strong> This ad has no buyer requests and can be deleted using the button above.</Alert>)}
                </div>
              </div>
            </div>
          )}
          {isAdSold() && (
            <div className="bg-white rounded-lg shadow-md overflow-hidden mb-6">
              <div className="p-6">
                <div className="text-center">
                  <CheckCircle sx={{ fontSize: 48, color: '#ce55b9', mb: 2 }} />
                  <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1, color: '#ce55b9' }}>Item Sold</Typography>
                  <Typography variant="body2" color="text.secondary">This item has been marked as sold</Typography>
                </div>
              </div>
            </div>
          )}
          <div className="bg-white rounded-lg shadow-md overflow-hidden mb-6">
            <div className="p-6">
              <h3 className="text-lg font-semibold mb-4 text-gray-800">Performance</h3>
              <div className="space-y-4">
                <div className="flex items-center justify-between"><span className="text-gray-600">Views</span><span className="font-bold text-lg text-blue-600">{ad.views}</span></div>
                <div className="flex items-center justify-between"><span className="text-gray-600">Listed</span><span className="font-medium">{ad.posted_on}</span></div>
                <Divider sx={{ my: 2 }} />
                <div className="flex items-center justify-between"><span className="text-gray-600">Total Requests</span><span className="font-bold text-lg" style={{ color: '#ce55b9' }}>{buyerRequests.length}</span></div>
                {pendingRequests.length > 0 && (<div className="flex items-center justify-between"><span className="text-gray-600">Pending Requests</span><span className="font-bold text-lg" style={{ color: '#d81b60' }}>{pendingRequests.length}</span></div>)}
                {approvedRequests.length > 0 && !ad.is_paid && (<div className="flex items-center justify-between"><span className="text-gray-600">Awaiting Payment</span><span className="font-bold text-lg" style={{ color: '#ff9800' }}>{approvedRequests.length}</span></div>)}
                {paidRequests.length > 0 && (<div className="flex items-center justify-between"><span className="text-gray-600">Payment Completed</span><span className="font-bold text-lg" style={{ color: '#ce55b9' }}>{paidRequests.length}</span></div>)}
                {ad.is_paid && (<><Divider sx={{ my: 1 }} /><Alert severity="info" variant="outlined" className="animate-glow" sx={{ bgcolor: '#f8f4f7' }}><strong>💰 Payment Received!</strong><br />Transaction completed successfully<br /><strong>Status:</strong> Ready for pickup</Alert></>)}
                {isAdSold() && !ad.is_paid && (<><Divider sx={{ my: 1 }} /><Alert severity="success" variant="outlined"><strong>✅ Item Sold</strong><br />This ad has been marked as sold</Alert></>)}
                {approvedRequests.length > 0 && !ad.is_paid && !isAdSold() && (<><Divider sx={{ my: 1 }} /><Alert severity="success" variant="outlined" className="animate-glow"><strong>🎉 {approvedRequests.length} request(s) approved!</strong><br />Waiting for payment completion</Alert></>)}
              </div>
            </div>
          </div>
          {buyerRequests.length > 0 && (
            <div className="bg-white rounded-lg shadow-md overflow-hidden">
              <div className="p-6">
                <h3 className="text-lg font-semibold mb-4 text-gray-800 flex items-center"><Notifications className="mr-2" />Quick Actions</h3>
                <Button variant="contained" fullWidth startIcon={<Notifications />} onClick={() => { const element = document.getElementById('buyer-requests-section'); element?.scrollIntoView({ behavior: 'smooth' }); }} sx={{ bgcolor: '#ce55b9', '&:hover': { bgcolor: '#b84ba3' }, mb: 2 }} className={ad.is_paid || approvedRequests.length > 0 ? "animate-pulse" : ""}>
                  {ad.is_paid ? 'Payment Completed' : approvedRequests.length > 0 ? 'Check Payment Status' : 'View All Requests'} ({buyerRequests.length})
                </Button>
                {pendingRequests.length > 0 && (<Alert severity="warning" variant="outlined" sx={{ mb: 2 }}>You have {pendingRequests.length} pending request(s) waiting for your response.</Alert>)}
                {ad.is_paid && (<Alert severity="info" variant="outlined" className="animate-glow" sx={{ bgcolor: '#f8f4f7' }}>🎉 Payment completed! Transaction successful - coordinate pickup with buyer.</Alert>)}
                {isAdSold() && !ad.is_paid && (<Alert severity="success" variant="outlined">✅ Item marked as sold.</Alert>)}
                {approvedRequests.length > 0 && !ad.is_paid && !isAdSold() && (<Alert severity="success" variant="outlined" className="animate-glow">🎉 {approvedRequests.length} request(s) approved! Waiting for payment completion.</Alert>)}
              </div>
            </div>
          )}
        </div>
      </div>
      {buyerRequests.length > 0 && (
        <div id="buyer-requests-section" className="mt-8">
          <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
            <div className="p-6 text-white" style={{ background: '#ce55b9' }}>
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center space-x-4">
                  <div className="bg-white/20 p-3 rounded-full"><Group fontSize="large" /></div>
                  <div>
                    <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 1 }}>{ad.is_paid ? 'Payment Completed Management' : 'Buyer Requests Management'}</Typography>
                    <Typography variant="body1" sx={{ opacity: 0.95 }}>{ad?.title}</Typography>
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
                <div className="bg-white/20 backdrop-blur-sm rounded-lg p-3 text-center">
                  <Typography variant="h6" sx={{ fontWeight: 'bold' }}>{buyerRequests.length}</Typography>
                  <Typography variant="caption">Total Requests</Typography>
                </div>
                <div className="bg-white/20 backdrop-blur-sm rounded-lg p-3 text-center">
                  <Typography variant="h6" sx={{ fontWeight: 'bold' }}>{ad.is_paid ? paidRequests.length : pendingRequests.length}</Typography>
                  <Typography variant="caption">{ad.is_paid ? 'Paid' : 'Pending'}</Typography>
                </div>
                <div className="bg-white/20 backdrop-blur-sm rounded-lg p-3 text-center">
                  <Typography variant="h6" sx={{ fontWeight: 'bold' }}>${buyerRequests.length > 0 ? formatPrice(Math.max(...buyerRequests.map(req => parseFloat(req.amount)))) : '0.00'}</Typography>
                  <Typography variant="caption">Highest Offer</Typography>
                </div>
                <div className="bg-white/20 backdrop-blur-sm rounded-lg p-3 text-center">
                  <Typography variant="h6" sx={{ fontWeight: 'bold' }}>${buyerRequests.length > 0 ? formatPrice(buyerRequests.reduce((sum, req) => sum + parseFloat(req.amount), 0) / buyerRequests.length) : '0.00'}</Typography>
                  <Typography variant="caption">Avg Offer</Typography>
                </div>
              </div>
              {ad.is_paid && (<Alert severity="info" variant="filled" sx={{ backgroundColor: 'rgba(255, 255, 255, 0.2)', color: 'white', border: '1px solid rgba(255, 255, 255, 0.5)', mb: 2, '& .MuiAlert-icon': { color: 'white' } }} icon={<CheckCircle />} className="animate-glow">💰 Payment completed successfully! All buyer requests have been updated to reflect payment status.</Alert>)}
              {approvedRequests.length > 0 && !ad.is_paid && (<Alert severity="success" variant="filled" sx={{ backgroundColor: 'rgba(255, 255, 255, 0.2)', color: 'white', border: '1px solid rgba(255, 255, 255, 0.5)', mb: 2, '& .MuiAlert-icon': { color: 'white' } }} icon={<CheckCircle />} className="animate-glow">🎉 {approvedRequests.length} request(s) approved! Buyer(s) notified to proceed with payment.</Alert>)}
              {pendingRequests.length > 0 && !ad.is_paid && (<Alert severity="warning" variant="filled" sx={{ backgroundColor: 'rgba(255,255,255,0.15)', color: 'white', border: '1px solid rgba(255,255,255,0.3)', '& .MuiAlert-icon': { color: 'white' } }} icon={<AccessTime />}>⏱️ {pendingRequests.length} request(s) need your immediate attention</Alert>)}
            </div>
            <div className="p-6">
              <Grid container spacing={3}>
                {buyerRequests.map((request, index) => renderBuyerRequestCard(request, index))}
              </Grid>
            </div>
          </div>
        </div>
      )}
      <Dialog open={soldConfirmOpen} onClose={() => setSoldConfirmOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Typography variant="h6">Mark as Sold</Typography>
          <IconButton onClick={() => setSoldConfirmOpen(false)}><Close /></IconButton>
        </DialogTitle>
        <DialogContent>
          <div className="text-center py-4">
            <CheckCircle sx={{ fontSize: 64, color: '#ce55b9', mb: 2 }} />
            <Typography variant="h6" sx={{ mb: 2 }}>Mark "{ad.title}" as Sold?</Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>This will mark your item as sold and notify potential buyers that it's no longer available.</Typography>
            {buyerRequests.length > 0 && (<Alert severity="info" sx={{ mb: 2, textAlign: 'left' }}><strong>Note:</strong> You have {buyerRequests.length} buyer request(s) for this item. Marking as sold will indicate the item is no longer available.</Alert>)}
            <Typography variant="body2" color="text.secondary">You can always edit your ad later if needed.</Typography>
          </div>
        </DialogContent>
        <DialogActions sx={{ p: 3, gap: 1 }}>
          <Button onClick={() => setSoldConfirmOpen(false)} variant="outlined" disabled={soldLoading}>Cancel</Button>
          <Button onClick={handleMarkAsSold} variant="contained" startIcon={soldLoading ? <CircularProgress size={16} /> : <CheckCircle />} disabled={soldLoading} sx={{ bgcolor: '#ce55b9', '&:hover': { bgcolor: '#b84ba3' } }}>
            {soldLoading ? 'Marking as Sold...' : 'Mark as Sold'}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={deleteDialogOpen} onClose={() => !deleteLoading && setDeleteDialogOpen(false)} maxWidth="sm" fullWidth disableEscapeKeyDown={deleteLoading}>
        <DialogTitle sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div className="flex items-center space-x-2">
            <Delete color="error" />
            <Typography variant="h6" color="error.main">{deleteLoading ? 'Deleting Ad...' : 'Confirm Delete'}</Typography>
          </div>
          {!deleteLoading && (<IconButton onClick={() => setDeleteDialogOpen(false)}><Close /></IconButton>)}
        </DialogTitle>
        <DialogContent>
          {deleteLoading ? (
            <div className="text-center py-6">
              <CircularProgress size={40} color="error" className="mb-4" />
              <Typography variant="h6" sx={{ mb: 2 }}>Deleting "{ad.title}"...</Typography>
              <Typography variant="body2" color="text.secondary">Please wait while we process your request</Typography>
            </div>
          ) : (
            <div className="py-2">
              <Alert severity="warning" sx={{ mb: 3 }}><strong>Warning!</strong> This action cannot be undone.</Alert>
              <Typography variant="body1" sx={{ mb: 2 }}>Are you sure you want to <strong>permanently delete</strong> "{ad.title}"?</Typography>
              {ad.is_paid && (<Alert severity="error" sx={{ mt: 2 }}><strong>Cannot Delete:</strong> Payment has been completed for this ad. Consider keeping it for transaction records.</Alert>)}
              {buyerRequests.length > 0 && !ad.is_paid && (<Alert severity="error" sx={{ mt: 2 }}><strong>Cannot Delete:</strong> This ad has {buyerRequests.length} buyer request(s). Ads with buyer requests cannot be deleted due to data integrity requirements.<br /><br /><strong>Alternative:</strong> Use "Mark as Sold" to indicate the item is no longer available.</Alert>)}
              {buyerRequests.length === 0 && !ad.is_paid && (<Alert severity="info" sx={{ mt: 2 }}><strong>Safe to Delete:</strong> This ad has no buyer requests and can be safely deleted.</Alert>)}
            </div>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 3, gap: 1 }}>
          <Button onClick={() => setDeleteDialogOpen(false)} variant="outlined" disabled={deleteLoading}>Cancel</Button>
          <Button onClick={handleDelete} variant="contained" color="error" startIcon={deleteLoading ? <CircularProgress size={16} color="inherit" /> : <Delete />} disabled={deleteLoading} className={deleteLoading ? "animate-pulse" : ""}>
            {deleteLoading ? 'Deleting...' : 'Delete Ad Permanently'}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AdsDetailsPage;